import {useUpdateHeaderTitle, usePermission} from "../hooks";
import {ExtraButtons} from "../components/extra-buttons";
import {Header} from "../components/layout/header";
import React from "react";
import {VisibilityProvider} from "../components/visibility-provider";
import {CreateDrawer, useGetData} from "../pages-lib/manual-orders";
import {useManageItems} from "../pages-lib/orders/model";
import {getColumns} from "../pages-lib/orders/table-columns";
import {OrderFilers} from "../pages-lib/orders/filters";
import {getFormattedItems} from "../pages-lib/orders/model/use-get-orders";
import {OrderExpandableRow} from "../pages-lib/orders/order-expandable-row";
import {EditDrawer} from "../pages-lib/orders/edit-drawer";
import {ChangePaymentDrawer} from "../pages-lib/orders/change-payment-drawer";
import {RefusedDrawer} from "../pages-lib/orders/refused-drawer";
import styled from "styled-components";
import { Table as AntTable } from "antd"

export default function ManualOrders() {
    const { hasPermission } = usePermission()
    const [createDrawerState, setCreateDrawerState] = React.useState(false)
    const [editDrawerState, setEditDrawerState] = React.useState(false);
    const [changePaymentDrawerState, setChangePaymentDrawerState] = React.useState(false);
    const [refusedDrawerState, setRefusedDrawerState] = React.useState(false);
    const [changePaymentValues, setChangePaymentValues] = React.useState(false);
    const [refusedData, setRefusedData] = React.useState([]);
    const [refusedDelivery, setRefusedDelivery] = React.useState(false)
    const [refusedAll, setRefusedAll] = React.useState(false)

    const {
        items,
        isLoading,
        pagination,
        refetch: getItems,
        isLoadingSearchData,
        handleSearchOrders,
        handleClearSearch,
        searchOrders,
        searchOrdersFull,
        onSearchUserAddresses,
        searchUsersAddresses,
        searchUsersAddressesFull,
        searchUser,
        getIntervals,
        intervals,
        createOrder,
        options,
        handleTableChange,
        handleSearchTable,
        handleClearFilter,
        handlePaymentCheck,
        resendToCrm,
    } = useGetData()

    const { editData, onEditItem, onSaveChange, sendPaymentUrlToEmail, sendRefusedItemsData, onPreCheck } =
        useManageItems(items, getItems, onSuccessEdit, closeRefusedDrawerState, clearRefusedData, options);

    const headerTitle = useUpdateHeaderTitle({
        items,
        defaultTitle: "0 Заказов",
        arrType: ["Заказ", "Заказы", "Заказов"],
    });

    const columns = getColumns(hasPermission("manual-orders.edit") ? onEditItem : null)

    function onSuccessEdit() {
        setEditDrawerState(!editDrawerState)
    }

    function handleSetChangeValue(values) {
        setChangePaymentValues(values)
    }

    function clearRefusedData() {
        setRefusedAll(false)
        setRefusedData([])
    }

    function closeChangePaymentDrawer() {
        setChangePaymentDrawerState(false)
    }

    function openChangePaymentDrawer() {
        setChangePaymentDrawerState(true)
    }

    function closeRefusedDrawerState() {
        setRefusedDrawerState(false)
        clearRefusedData()
        clearRefusedDeliveryClear()
    }

    function clearRefusedDeliveryClear() {
        setRefusedDelivery(false)
    }

    function openRefusedDrawerState() {
        setRefusedDrawerState(true)
    }

    function closeAndClear() {
        setEditDrawerState(false)
        closeRefusedDrawerState()
    }

    return (
        <>
            <Header
                title={headerTitle}
                extra={
                    <ExtraButtons
                        onCreate={hasPermission("manual-orders.create") ? () => setCreateDrawerState(true) : undefined}
                        titles={{ onCreate: "Создать заказ" }}
                    />
                }
            />
            <OrderFilers handleSearch={ handleSearchTable } handleClearFilter={handleClearFilter} />
            {hasPermission("manual-orders.create") && <VisibilityProvider visible={createDrawerState}>
                <CreateDrawer
                    title={"Создание заказа"}
                    onClose={() => setCreateDrawerState(false)}
                    initialValues={null}
                    onSave={createOrder}
                    isLoadingSearchData={isLoadingSearchData}
                    onSearchOrders={handleSearchOrders}
                    onClearSearchOrders={handleClearSearch}
                    searchOrderData={searchOrders}
                    searchOrdersFull={searchOrdersFull}
                    pointOptions={options.pointOptions}
                    deliveryTypes={options.deliveryTypes}
                    paymentTypes={options.paymentTypes}
                    onSearchUserAddresses={onSearchUserAddresses}
                    searchUserAddresses={searchUsersAddresses}
                    searchUsersAddressesFull={searchUsersAddressesFull}
                    searchUser={searchUser}
                    getIntervals={getIntervals}
                    intervals={intervals}
                    onPreCheck={onPreCheck}
                />
            </VisibilityProvider>}

            <StyledTable
                dataSource={getFormattedItems(items)}
                columns={columns}
                pagination={pagination}
                loading={isLoading}
                onChange={handleTableChange}
                expandable={{
                    expandedRowRender: (record) =>
                        <OrderExpandableRow
                            data={record}
                            onPayment={handlePaymentCheck}
                            onSend={resendToCrm}
                        />
                }}
            />

            <VisibilityProvider visible={editDrawerState}>
                <EditDrawer
                    onClose={() => closeAndClear()}
                    initialValues={editData}
                    title={"Просмотр заказа"}
                    handleSetChangeValue={handleSetChangeValue}
                    openChangePaymentDrawer={openChangePaymentDrawer}
                    openRefusedDrawerState={openRefusedDrawerState}
                    sendPaymentUrlToEmail={sendPaymentUrlToEmail}
                    refusedData={refusedData}
                    setRefusedData={setRefusedData}
                    refusedDelivery={refusedDelivery}
                    setRefusedDelivery={setRefusedDelivery}
                    setRefusedAll={setRefusedAll}
                />
            </VisibilityProvider>

            <VisibilityProvider visible={changePaymentDrawerState}>
                <ChangePaymentDrawer
                    title={"Изменить тип оплаты"}
                    onClose={closeChangePaymentDrawer}
                    initialValues={changePaymentValues}
                    paymentTypesOption={options.paymentTypes}
                    handleSetChangeValue={handleSetChangeValue}
                    onSaveChange={onSaveChange}
                />
            </VisibilityProvider>

            <VisibilityProvider visible={refusedDrawerState}>
                <RefusedDrawer
                    title={"Возврат позиций"}
                    onClose={closeRefusedDrawerState}
                    initialValues={refusedData}
                    orderData={editData}
                    refusedDelivery={refusedDelivery}
                    onSaveChange={sendRefusedItemsData}
                    allRefused={refusedAll}
                />
            </VisibilityProvider>
        </>
    );
}

const StyledTable = styled(AntTable)`
  .row-can-view {
    cursor: pointer;
  }
`